// project import
import { Route, Routes } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import React, { Suspense } from 'react';
import routes from './routes';
import { Navigate } from 'react-router';
import MainLayout from './layout/MainLayout';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <ThemeCustomization>
    <ScrollTop>
      <Routes>
        {routes.map((item) => {
          const element = item.private ? (
            <PrivateRoute element={item.Component} />
          ) : (
            <item.Component />
          );

          return <Route key={item.path} path={item.path} element={element} />;
        })}
      </Routes>
    </ScrollTop>
  </ThemeCustomization>
);
export const PrivateRoute = ({ element: Component }) => {
  const user =
    (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'))) ||
    (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')));

  return user ? (
    <MainLayout>
      <Component />
    </MainLayout>
  ) : (
    <Navigate to={{ pathname: '/login' }} replace />
  );
};

export default App;
